import style from "../style/layout.module.css";
import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Colors,
} from "chart.js";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import { Radar } from "react-chartjs-2";
import { useRecoilState } from "recoil";
import { AtomScore } from "../store/store";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Colors
);

export default function Ideal() {
  const LIMIT_POINT = 30;
  const [radarData, setRadarData] = useRecoilState(AtomScore);
  const ideal = [
    { name: "키", title: "height", value: 1 },
    { name: "직업", title: "job", value: 1 },
    { name: "학력", title: "degree", value: 1 },
    { name: "집안", title: "family", value: 1 },
    { name: "경제력", title: "economy", value: 1 },
  ];

  const data = {
    labels: ideal.map((list) => list.name),
    datasets: [
      {
        label: "나의 이상형은?",
        data: Object.values(radarData)?.map((value) => value),
        backgroundColor: ({ chart: { ctx } }) => {
          const bg = ctx.createLinearGradient(0, 150, 0, 400);
          bg.addColorStop(0, "#e08a50a6");
          bg.addColorStop(1, "#e7bd8a62");
          return bg;
        },
        borderColor: "transparent",
        borderWidth: 0,
        color: "red",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      r: {
        pointLabels: {
          font: {
            size: 16, // 폰트 크기 설정
          },
        },
        min: 0,
        max: 10,
        ticks: {
          stepSize: 1,

          color: "transparen",
          backdropColor: "transparent",
        },
      },
    },
  };
  const totalPoint = Object.values(radarData)
    .map((li) => li)
    .reduce((a, b) => {
      return a + b;
    });

  return (
    <div className={style.ideal}>
      <h4 className={style.ideal_title}>선호 이상형 등급기준</h4>
      <p className={style.ideal_msg}>30포인트를 원하시는 항목에 분배해주세요</p>

      <div
        style={{
          position: "relative",
          width: "99%",
          height: "auto",
          aspectRatio: "1/1",
        }}
      >
        <Radar data={data} options={options} />
      </div>
      {ideal.map((list, i) => (
        <TextInput
          key={list.title}
          title={list.title}
          name={list.name}
          setRadarData={setRadarData}
          radarData={radarData}
          limit={LIMIT_POINT}
          totalPoint={totalPoint}
        />
      ))}
      <p className={style.amount}>잔여 포인트 : {LIMIT_POINT - totalPoint}</p>
    </div>
  );
}

const TextInput = ({
  title,
  name,
  setRadarData,
  radarData,
  limit,
  totalPoint,
}) => {
  const [number, setNumber] = useState(1);

  const handleMinus = () => {
    if (number > 1) {
      setNumber((prev) => prev - 1);
    }
  };
  const handlePlus = () => {
    if (totalPoint >= limit) {
      alert("잔여 포인트가 없습니다.");
    }
    if (number < 10 && totalPoint < limit) {
      setNumber((prev) => prev + 1);
    }
  };

  const onChangeHandler = (title, number) => {
    setRadarData((prev) => {
      return {
        ...prev,
        [title]: number,
      };
    });
  };
  useEffect(() => {
    onChangeHandler(title, number);
  }, [number]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        marginBottom: "10px",
        height: "19px",
      }}
    >
      <span className="progress_text">{name}</span>

      <button type="button" onClick={handleMinus}>
        <AiOutlineMinus style={{ height: "100%", fontSize: 20 }} />
      </button>

      <progress value={number} max={10}></progress>
      <button
        type="button"
        onClick={handlePlus}
        name={title}
        id={title}
        className="input_text"
      >
        <AiOutlinePlus style={{ height: "100%", fontSize: 20 }} />
      </button>
      <p style={{ marginTop: -2, width: 17, fontSize: 18 }}>{number}</p>
    </div>
  );
};
